import * as activityLogger from "../../helpers/activity-logger";
import Route from '../../route';
$(function () {

    if ($(".plp-container").length !== 0) {

        $(document).on('click', '.title-row', function () {
            if (!$(this).hasClass('disabled')) {
                const wineInbond = $(this).closest(".wine-inbond")[0];
                wineInbond.classList.toggle("open");
                
                const productName = wineInbond.querySelector('.title').textContent.trim().replace(/\s\s+/g, ' ');
                const price = wineInbond.querySelector('.product_price').textContent.trim().replace(/\s\s+/g, ' ');
                const offers = wineInbond.querySelectorAll('.offer[data-code]');
                const dataCodes = Array.from(offers).map(offer => offer.getAttribute('data-code'));

                const productData = {
                    'productName': productName,
                    'price': price,
                    'numberOfRows': offers.length,
                    'rowDataCodes': dataCodes
                };

                activityLogger.logActivity('Row: expand', Route, productData);
            }
        });
    }

    $(document).on('click', '.product_wrapper .price-toggle .view-less', function () {
        $(this).closest('.offer').removeClass('active');
        toggleExtraPrices($(this));
    });

    $(document).on('click', '.product_wrapper .view-more', function () {
        $(this).closest('.offer').addClass('active');
        toggleExtraPrices($(this));
    });

    function toggleExtraPrices($toggleEelement) {
        let $parent = $toggleEelement.closest('.parent');
        let $sibling = $parent.next();
        while ($sibling.length && $sibling.hasClass('child')) {
            $sibling.toggleClass('d-none');
            $sibling = $sibling.next();
        }
    }
    
});